var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{directives:[{name:"translate",rawName:"v-translate:_formattedBody",value:({
    key: _vm.translationKeyInitial,
    val: _vm.lang,
    optionId: _vm.option.id,
    html: _vm.formattedBody,
    optionLable: _vm.optionLable
  }),expression:"{\n    key: translationKeyInitial,\n    val: lang,\n    optionId: option.id,\n    html: formattedBody,\n    optionLable\n  }",arg:"_formattedBody"}],domProps:{"innerHTML":_vm._s(_vm.formattedBody)}})}
var staticRenderFns = []

export { render, staticRenderFns }